<template>
  <div @click="toggleTheme">
    <div
      class="button-style btn-add3 tr-all-03 z-5000 op-50-hover theme-switch"
    >
      {{ themeText }}
    </div>
  </div>
</template>

<script setup>
// src/components/extras/ThemeSwitcher.vue
import { useTheme } from '@/composables/useTheme'
import { ref } from 'vue'

const { isDarkMode, toggleDarkMode } = useTheme()
const themeText = ref(isDarkMode.value ? '–' : 'o')

const toggleTheme = () => {
  toggleDarkMode()
  themeText.value = isDarkMode.value ? '–' : 'o'
}
</script>
<style scoped>
.theme-switch {
  text-transform: lowercase !important;
}
</style>
